// import { gsap } from 'gsap';
// import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

window.bgAuraFunc = function bgAuraFunc() {
  const bodyBg = document.querySelector('.body-bg');
  const bodyAuraBg = document.querySelector('.bg-aura');

  if (!bodyBg || !bodyAuraBg) return;

  if (window.innerWidth > 1024) {
    const bodyAuraMask = document.querySelector('.bg-aura-mask');

    window.addEventListener('resize', () => {
      if (bodyAuraMask) {
        bodyAuraMask.style.mixBlendMode = 'normal';
        requestAnimationFrame(() => {
          // markers: true,
          bodyAuraMask.style.mixBlendMode = 'soft-light';
        });
      }
    });

    let mouseX = 0;
    let mouseY = 0;
    let posX = 0;
    let posY = 0;

    const speed = 0.1;

    window.addEventListener('mousemove', (e) => {
      // Учитываем прокрутку страницы
      mouseX = e.clientX + window.scrollX;
      mouseY = e.clientY + window.scrollY;
    });

    function animateAura() {
      posX += (mouseX - posX) * speed;
      posY += (mouseY - posY) * speed;

      gsap.to(bodyAuraBg, {
        x: posX,
        y: posY,
        duration: 0.3,
        ease: 'power2.out',
        overwrite: 'auto',
      });

      requestAnimationFrame(animateAura);
    }

    animateAura();
  }
};

bgAuraFunc();
